import { batch, signal } from '@preact/signals-react'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import { formData } from '@signals'

export const selectedMappingId = signal(null)
export const mappingFormData = signal({})
export const acrissTable = signal([])
export const categoriesTable = signal([])
export const mappingType = signal(MAPPING_TYPE.ACRISS)
export const errorRegistry = signal({})
export const bulkFieldModal = signal(null)
// null = closed | { field: 'countries'|'offices'|'sites'|'providers', values: [], rows: [] }

//functions
export const setMappingFormData = (path, method) => {
	formData.value = {
		idCustom: null,
		idOffices: [],
		idCountries: [],
		sites: [],
		idCategory: null,
		idProviders: null,
		model: null,
		automatic: null,
		doors: null,
		seats: null,
		isCompany: false,
		acriss: null,
		airCondition: null,
		method: method,
	}
	mappingType.value = path
}

export const clearSignals = () => batch(() => {
	selectedMappingId.value = null
	formData.value = {}
	acrissTable.value = []
	categoriesTable.value = []
	mappingType.value = MAPPING_TYPE.ACRISS
	errorRegistry.value = {}
})
